<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar title="更换手机号"></ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="editPassword_container">
                <div class="prompt ta-c"><span v-if="speed == 1">修改后将使用新手机号登录此账号,公司通讯录中的手机号也将同步修改！</span></div>
                <van-form >
                    <ul v-if="speed == 1">
                        <li>
                            <van-field  input-align="right" name="当前手机号"   label="当前手机号"  placeholder="当前手机号" v-model="replacePhoneFrom.phone" readonly ></van-field>
                        </li>
                        <li>
                            <van-field name="获取验证码"   placeholder="获取验证码" v-model="replacePhoneFrom.code">
                                <template #button>
                                    <span class="line"></span><button :disabled="getCodeBtnDisabled1" class="btn_primary" @click="handleClickGetCode(1)">{{getCodeText1}}</button>
                                </template>
                            </van-field>
                        </li>
                    </ul>

                    <ul v-else>
                        <li>
                            <van-field  input-align="right" name="新手机号"   label="新手机号"  placeholder="请输入" v-model="replacePhoneFrom.newPhone"  ></van-field>
                        </li>
                        <li>
                            <van-field name="获取验证码"   placeholder="获取验证码" v-model="replacePhoneFrom.newCode">
                                <template #button>
                                    <span class="line"></span><button :disabled="getCodeBtnDisabled2"  class="btn_primary" @click="handleClickGetCode(2)">{{getCodeText2}}</button>
                                </template>
                            </van-field>
                        </li>
                    </ul>
                    <div class="btn_container">
                        <van-button type="info" round block @click="handleClickConfirm" :disabled="btnDisabled"  :text="speed == 1 ? '下一步' : '确定'"></van-button>
                    </div>

                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
import { SendPhoneCode,CheckVerifyCode,ChangePhoneNum } from "@/api/index";
import ReturnNavBar from '@/components/mComponents/ReturnNavBar.vue'
import {mapState} from "vuex";
export default {
    name: 'mobileReplacePhone',
    data () {
        return {
            replacePhoneFrom:{
                phone:'',
                code:'',
                newPhone:'',
                newCode:''
            },
            speed:1,

            getCodeBtnDisabled1:false,
            getCodeTime1:60,
            getCodeBtnDisabled2:false,
            getCodeTime2:60,
            btnDisabled:false
        }
    },
    computed: {
        ...mapState(['userInfo']),
        getCodeText1() {
            if (this.getCodeBtnDisabled1) {
                return `${this.getCodeTime1}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        },
        getCodeText2() {
            if (this.getCodeBtnDisabled2) {
                return `${this.getCodeTime2}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        }
    },
    created() {
        if(this.userInfo && this.userInfo.user){
            this.replacePhoneFrom.phone = this.userInfo.user.phone
        }
    },
    mounted () {

    },
    methods: {

        // 获取验证码
        handleClickGetCode(type){
            if (type == 2 && !this.replacePhoneFrom.newPhone) {
                return this.$message.error('请输入新的手机号')
            }
            SendPhoneCode({
                phone: type == 1 ? this.replacePhoneFrom.phone : this.replacePhoneFrom.newPhone,
                type: type == 1 ? "change" : "change_code"
            }).then(res => {
                if (res.code === 200) {
                    this.$toast('验证码发送成功')
                    if (type == 1) {
                        this.getCodeBtnDisabled1 = true;
                        const timer = setInterval(() => {
                            if (this.getCodeTime1 > 0) {
                                this.getCodeTime1--;
                            } else {
                                this.getCodeBtnDisabled1 = false;
                                clearInterval(timer);
                                this.getCodeTime1 = 60;
                            }
                        }, 1000);
                    } else {
                        this.getCodeBtnDisabled2 = true;
                        const timer = setInterval(() => {
                            if (this.getCodeTime2 > 0) {
                                this.getCodeTime2--;
                            } else {
                                this.getCodeBtnDisabled2 = false;
                                clearInterval(timer);
                                this.getCodeTime2 = 60;
                            }
                        }, 1000);
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        handleClickConfirm(){
            if(this.speed == 1){
                if(this.replacePhoneFrom.code == ''){
                    this.$toast('请输入验证码');
                    return false
                }
                this.$toast.loading({
                    message: '请稍后...',
                    forbidClick: true,
                    overlay:true
                });
                this.btnDisabled = true
                const data = {
                    phone: this.replacePhoneFrom.phone,
                    code: this.replacePhoneFrom.code,
                    type: "change"
                }
                CheckVerifyCode(data).then(res => {
                    if (res.code == 200) {
                        this.speed = 2;
                    }
                    this.$toast.clear();
                    this.btnDisabled = false
                }).catch(() => {
                    this.$toast.clear();
                    this.btnDisabled = false
                })
            }else{
                if(!this.replacePhoneFrom.newPhone){
                    return this.$toast('请输入新手机号');
                }
                if(!this.replacePhoneFrom.newCode){
                    return this.$toast('请输入验证码');
                }
                this.$toast.loading({
                    message: '请稍后...',
                    forbidClick: true,
                    overlay:true
                });
                this.btnDisabled = true;
                let data = {
                    phone: this.replacePhoneFrom.newPhone,
                    code: this.replacePhoneFrom.newCode,
                    type: "change_code"
                };
                ChangePhoneNum(data).then(res => {
                    if (res.code == 200) {
                        this.$toast({
                            message: "更换成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$router.go(-1);
                            },
                        });
                    }
                    this.btnDisabled = false;
                    this.$toast.clear();
                }).catch(() => {
                    this.$toast.clear();
                    this.btnDisabled = false;
                })
            }
        },
    },
    components: {
        ReturnNavBar
    }
}
</script>

<style lang="scss" scoped>

</style>
